import TranslationsHeader from "./translations-header";
export default TranslationsHeader;